import { createAsyncThunk } from "@reduxjs/toolkit";
import { fwRpc } from "api";
import { setErrorSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { MinioFirewallConfigData } from "../../api/firewallApi";

export interface ResourceRequest {
  siteId: string;
  namespace: string;
  resourceId: string;
}

export interface FWUpdateRequest {
  siteId: string;
  namespace: string;
  resourceId: string;
  configData: MinioFirewallConfigData;
}

export const fetchFwCfg = createAsyncThunk(
  "firewall/fetchFwCfg",
  async (req: ResourceRequest, { rejectWithValue, getState }) => {
    return fwRpc.api
      .getFirewallConfig(req.siteId, req.namespace, req.resourceId)
      .then((res) => {
        if (res.data !== undefined) {
          return res.data;
        }
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const updateFwCfg = createAsyncThunk(
  "firewall/updateFwCfg",
  async (req: FWUpdateRequest, { rejectWithValue, dispatch }) => {
    return fwRpc.api
      .updateFirewall(req.siteId, req.namespace, req.resourceId, {
        configData: req.configData,
      })
      .then((res) => {
        if (res.data !== undefined) {
          dispatch(fetchFwCfg(req));
          return res.data;
        }
      })
      .catch((err) => {
        console.log(err);
        return rejectWithValue(err);
      });
  },
);

export const fetchFirewallDetails = createAsyncThunk(
  "firewall/getFirewallDetails",
  async (req: ResourceRequest, { rejectWithValue, dispatch }) => {
    return fwRpc.api
      .getFirewallConfig(req.siteId, req.namespace, req.resourceId)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const deleteFirewallInstance = createAsyncThunk(
  "firewal/deleteFirewallInstance",
  async (
    requestElements: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch },
  ) => {
    return fwRpc.api
      .deleteFirewall(
        requestElements.siteID,
        requestElements.namespace,
        requestElements.resourceID,
      )
      .then(() => {})
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);
